import React from "react";
// import {AuthProvider} from './auth-context'
import { UserProvider } from "./userContext";

function AppProviders({ children }) {
  return <UserProvider>{children}</UserProvider>;
}

export default AppProviders;
